/**
 * ApprovalEntry — present a product/option for the client to approve or push back on.
 * data: { intro?: markdown, imageUrl?: string, optionLabel?: string }
 * Client actions: approve  |  request_changes (with a note).
 * On return, the recorded decision is shown.
 */

import { useState } from 'react'
import Markdown from '../../components/Markdown.jsx'
import { J, PrimaryButton, GhostButton, DoneChip, ViewOnlyNote } from '../journeyUI.jsx'

export default function ApprovalEntry({ entry, response, onRespond, viewOnly }) {
  const [mode, setMode] = useState(null) // null | 'changes'
  const [note, setNote] = useState('')

  const decided = response && (response.kind === 'approve' || response.kind === 'request_changes')

  if (decided) {
    const approved = response.kind === 'approve'
    return (
      <div>
        <div style={J.eyebrow}>Approval</div>
        <h2 style={J.title}>{entry.title || 'For your approval'}</h2>
        <hr style={J.rule} />
        {entry.data?.imageUrl && (
          <img src={entry.data.imageUrl} alt="" style={{ width: '100%', borderRadius: 10, marginBottom: 18 }} />
        )}
        <div style={{ marginTop: 8 }}>
          <DoneChip>{approved ? 'Approved' : 'Changes requested'}</DoneChip>
          {response.payload?.note && (
            <div style={{ ...J.body, marginTop: 14, fontStyle: 'italic' }}>&ldquo;{response.payload.note}&rdquo;</div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div>
      <div style={J.eyebrow}>Approval</div>
      <h2 style={J.title}>{entry.title || 'For your approval'}</h2>
      <hr style={J.rule} />
      {entry.data?.imageUrl && (
        <img src={entry.data.imageUrl} alt="" style={{ width: '100%', borderRadius: 10, marginBottom: 18 }} />
      )}
      {entry.data?.intro && (
        <div style={{ ...J.body, marginBottom: 20 }}><Markdown text={entry.data.intro} /></div>
      )}

      {viewOnly ? <ViewOnlyNote /> : mode === 'changes' ? (
        <div>
          <textarea
            value={note} onChange={e => setNote(e.target.value)} autoFocus
            placeholder="What would you like changed?"
            style={{
              width: '100%', minHeight: 90, padding: 12, borderRadius: 10, resize: 'vertical',
              border: '0.5px solid rgba(7,39,45,0.25)', fontFamily: '"DM Sans", sans-serif',
              fontSize: 14, color: '#07272D', outline: 'none', boxSizing: 'border-box',
            }} />
          <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
            <PrimaryButton disabled={!note.trim()} onClick={() => onRespond('request_changes', { note: note.trim() })}>
              Send request
            </PrimaryButton>
            <GhostButton onClick={() => { setMode(null); setNote('') }}>Cancel</GhostButton>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', gap: 10 }}>
          <PrimaryButton onClick={() => onRespond('approve')}>{entry.data?.optionLabel ? 'Approve ' + entry.data.optionLabel : 'Approve'}</PrimaryButton>
          <GhostButton onClick={() => setMode('changes')}>Request changes</GhostButton>
        </div>
      )}
    </div>
  )
}
